<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Grafikoni</p>
      </sidebar-link>      
      <sidebar-link to="/intermediate">
        <md-icon>content_paste</md-icon>
        <p>Neodobreni unosi</p>
      </sidebar-link>
      <sidebar-link to="/cleantable">
        <md-icon>library_books</md-icon>
        <p>Odobreni unosi</p>
      </sidebar-link>
      <sidebar-link to="/negatori">
        <md-icon>person</md-icon>
        <p>Spisak negatora</p>
      </sidebar-link>
      <sidebar-link to="/platforme">
        <md-icon>newspaper</md-icon>
        <p>Spisak platformi</p>
      </sidebar-link>
      <!--
      <div v-if="!$auth.loading">
        <button v-if="!$auth.isAuthenticated" @click="login">Log in</button>
        <button v-if="$auth.isAuthenticated" @click="logout">Log out</button>
      </div>
      -->
    </side-bar>

    <div class="main-panel">

      <dashboard-content> </dashboard-content>
    </div>
  </div>
</template>

<script>
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";

export default {
  components: {
    DashboardContent,
    MobileMenu
  },
  methods:{
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    }    
  },
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg")
    };
  }
};
</script>
